import * as React from 'react'

import useI18n from '@store/i18n/useI18n'
import Theme from '@theme/Theme'
import styled from '@theme/styled-components'

import Loader from 'react-loader-spinner'
import Images from '@components/images/images'
import { motion, container, item } from '@utils/Motion'

interface Props {
  navigation: Navigation
  screenStatus: ScreenStatus
  pictures: BusinessDeclarationPicture[]
}

const PicturesDetailsMenu = ({ navigation, screenStatus, pictures }: Props) => {
  const i18n = useI18n()

  return (
    <Container>
      <ScreenTitleContainer>
        <ScreenTitle>
          {screenStatus === 'loading'
            ? i18n.t('components.detailsChantier.title.loading')
            : i18n.t(`components.menu.photoCount`, { count: pictures.length })}
        </ScreenTitle>
        <Back onClick={() => navigation.goBack()}>{i18n.t('components.menu.back')}</Back>
      </ScreenTitleContainer>
      {screenStatus !== 'fetched' ? (
        screenStatus === 'loading' ? (
          <StatusContainer>
            <Loader type="ThreeDots" color={Theme.colors.classicButtonLoader} height={30} />
          </StatusContainer>
        ) : (
          <ErrorContainer>
            <ErrorLibelle>{i18n.t('components.detailsChantier.error')}</ErrorLibelle>
          </ErrorContainer>
        )
      ) : (
        <ImagesContainer as={motion.div} className="container" variants={container} initial="hidden" animate="visible">
          {pictures.length === 0 ? (
            <NoPhotoLibelle>{i18n.t('components.detailsChantier.noPhoto')}</NoPhotoLibelle>
          ) : (
            pictures.map((p, idx) => (
              <motion.div key={p.id} className="item" variants={idx > 20 ? undefined : item}>
                <Images
                  key={p.id}
                  imageId={p.id}
                  index={idx}
                  images={pictures}
                  status={(p as BusinessDeclarationPicture).status}
                />
              </motion.div>
            ))
          )}
        </ImagesContainer>
      )}
    </Container>
  )
}

export default PicturesDetailsMenu

const Container = styled('div')`
  flex: 1;
  display: flex;
  overflow: hidden;
  margin-bottom: 10px;
  flex-direction: column;
  padding: 10px;
`
const StatusContainer = styled('div')`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
`
const ErrorContainer = styled('div')`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`
const ErrorLibelle = styled('div')`
  ${(props) => props.theme.fonts.noItem};
  text-align: center;
  margin: 40px;
`
const Back = styled('div')`
  ${(props) => props.theme.fonts.backLibelle};
  cursor: pointer;
`
const ScreenTitle = styled('div')`
  ${(props) => props.theme.fonts.title};
`
const ScreenTitleContainer = styled('div')`
  border: 0px solid ${(props) => props.theme.colors.menuBorder};
  border-bottom-width: 1px;
  border-top-width: 1px;
  padding: 15px 0;

  display: flex;
  align-items: center;
  justify-content: space-between;
`
const ImagesContainer = styled('div')`
  overflow: scroll;
  display: flex;
  flex-wrap: wrap;
  padding-top: 10px;
  padding-bottom: 200px;
`
const NoPhotoLibelle = styled('div')`
  ${(props) => props.theme.fonts.noItem};
  text-align: center;
  margin: 40px;
`
